export default __webpack_public_path__ + "static/media/digna-tutorial-6.8617c2e6.gif";